export default __webpack_public_path__ + "static/media/careandcoach_white.275c514b.svg";